export default __webpack_public_path__ + "static/media/Recipe_Logo.b9ebe028.png";